// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#resident-group-edit[data-v-3d9c812d]{max-width:740px;margin-left:auto;margin-right:auto}#resident-group-edit .cancel-btn[data-v-3d9c812d],#resident-group-edit .update-btn[data-v-3d9c812d]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
